import { usePublicEventOptions } from "../../../common/public-options";
import type { DropdownOption } from "../types/event.types";

interface UseEventOptionsReturn {
  categoryOptions: DropdownOption[];
  fetchCategoryOptions: () => Promise<void>;
  subCategoryOptions: DropdownOption[];
  fetchSubCategoryOptions: () => Promise<void>;
}

export const useEventOptions = (organizationId?: string): UseEventOptionsReturn => {
  const {
    categoryOptions,
    fetchCategoryOptions,
    interestOptions: subCategoryOptions,
    fetchInterestOptions: fetchSubCategoryOptions,
  } = usePublicEventOptions(organizationId);

  return {
    categoryOptions,
    fetchCategoryOptions,
    subCategoryOptions,
    fetchSubCategoryOptions,
  };
};
